import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { fetchImages } from "../../../redux/actions/chatbotActions/getImagesActions";
import { RiGalleryLine } from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai"; // Loading spinner
import { useEffect } from "react";

const GetImagesComponent = ({
    name,
    control,
    updateData = false, // If true, hide the button
    errors,
    placeholder = "Enter number...",
    maxLength = 6,
    className = "w-full border rounded px-3 py-2",
    setValue,
}) => {
    const dispatch = useDispatch();
    const { imageLoading, imageData } = useSelector((state) => ({
        imageLoading: state.getImagesReducer.loading,
        imageData: state.getImagesReducer.images,
    }));

    useEffect(() => {
        if (imageData?.images) {
            setValue("creative_media", imageData.images);
            setValue("detail_url", imageData?.detail_url);

        }
    }, [imageData, setValue])

    return (
        <div>
            <label className="block font-medium text-gray-700 mb-1">{placeholder}</label>
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <>
                        <div className="flex gap-2 items-center">
                            <input
                                {...field}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={maxLength}
                                placeholder={placeholder}
                                className={className}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "").slice(0, maxLength);
                                    field.onChange(e);
                                }}
                                disabled={updateData} // Disable input if updateData is true
                            />
                            {/* Only show button if updateData is false */}
                            {!updateData && field.value?.length > 0 && (
                                <button
                                    type="button"
                                    className={`flex items-center gap-2 px-4 py-2 rounded text-white transition ${imageLoading
                                        ? "bg-gray-400 cursor-not-allowed"
                                        : "bg-blue-600 hover:bg-blue-700"
                                        }`}
                                    onClick={() => !imageLoading && dispatch(fetchImages(field.value))}
                                    disabled={imageLoading}
                                >
                                    {imageLoading ? (
                                        <AiOutlineLoading3Quarters className="animate-spin" size={18} />
                                    ) : (
                                        <RiGalleryLine size={18} />
                                    )}
                                </button>
                            )}
                        </div>
                        <p className="text-sm font-medium mt-1 text-blue-500 text-right">
                            {field.value?.length || 0}/{maxLength}
                        </p>
                    </>
                )}
            />
            {errors[name] && (
                <p className="text-red-500 text-sm">{errors[name]?.message}</p>
            )}
        </div>
    );
};

export default GetImagesComponent;
